export enum DonorConnectGroup {
    Nkdo = 0,
    Nkf = 1
}